import * as React from "react";
import { Provider } from "mobx-react";
import { rootStore } from "#stores/index";

export function MobxProvider(props: React.PropsWithChildren<{}>) {
	return <Provider {...rootStore}>{props.children}</Provider>;
}
